import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, OnChanges, ViewChild } from '@angular/core';

import { ComposableInputComponent, ComposableInputComponentBlock, ComposableInputMessage } from '../composable-input';
import { FocusableComponent } from '../focusable';

@Component({
  selector: 'vi-ui-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchBarComponent extends FocusableComponent implements OnChanges {
  @Input() public messages: ComposableInputMessage[] = [];
  @Input() public placeholder: string = '';

  @Output() messagesChange = new EventEmitter<ComposableInputMessage[]>();
  @Output() componentDeleted = new EventEmitter<ComposableInputComponentBlock>();
  @Output() currentFocused = new EventEmitter<{ messageOffset: number; messageContent: string }>();
  @Output() searchClicked = new EventEmitter<void>();
  @ViewChild('input') public input!: ComposableInputComponent;

  public isSearching = false;

  public constructor() {
    super();
  }

  public ngOnChanges(): void {
    this.isSearching =
      this.messages &&
      this.messages.length > 0 &&
      !(this.messages?.length === 1 && typeof this.messages[0] === 'string' && (this.messages[0] as string).trim() === '');
  }

  public handleIconClicked(): void {
    if (!this.isSearching) {
      return;
    }
    this.isSearching = false;
    this.messages = [];
    this.messagesChange.emit(this.messages);
    setTimeout(() => {
      if (this.input) {
        this.input.focus();
      }
    });
  }

  public focus() {
    this.input?.focus();
  }

  public focusMessageIndex(index: number, isStart = true) {
    this.input?.focusMessageIndex(index, isStart);
  }

  public handleMessagesChange(messages: ComposableInputMessage[]): void {
    this.messages = messages;
    this.messagesChange.emit(messages);
    this.isSearching = messages.length > 0;
  }

  public handleComponentDeleted(component: ComposableInputComponentBlock): void {
    this.componentDeleted.emit(component);
    this.isSearching = this.messages.length > 0;
  }

  public handleCurrentFocused(event: { messageOffset: number; messageContent: string }): void {
    this.currentFocused.emit(event);
  }

  public handleSearchClicked(event?: Event): void {
    event?.preventDefault();
    this.searchClicked.emit();
  }
}
